module.exports = __webpack_public_path__ + "img/video.a6b7f784.png";